import { KeyFigure, Reference } from '../types/content';

export const referencesTop: Reference[] = [
  { name: 'Nébuleuse — Arena Tour', kind: 'Tournée' },
  { name: 'Mira Valens', kind: 'Artiste' },
  { name: 'Agence Halo Events', kind: 'Agence' },
  { name: 'Festival Lumina', kind: 'Festival' },
  { name: 'Opéra Nomade', kind: 'Spectacle' },
  { name: 'Studio Kinetik', kind: 'Scénographe' },
];

export const referencesBottom: Reference[] = [
  { name: 'Parc des Lueurs', kind: 'Parcours nocturne' },
  { name: 'Zénith Tour 26', kind: 'Tournée' },
  { name: 'Collectif Hors-Champ', kind: 'Artistes' },
  { name: 'Maison Ardent', kind: 'Marque' },
  { name: 'Polaris Live', kind: 'Agence' },
  { name: 'Les Grandes Nuits', kind: 'Événement' },
];

export const keyFigures: KeyFigure[] = [
  { value: '380+', label: 'décors et volumes livrés depuis 2009' },
  { value: '62', label: 'tournées équipées' },
  { value: '14 m', label: 'notre plus haute sculpture' },
  { value: '48 h', label: 'pour une première faisabilité' },
];
